import { useContext } from "react";
import SidebarContext from "../context/SidebarProvider.tsx";

function useSidebar() {
  return useContext(SidebarContext);
}

export default useSidebar;
